// extracted by css-extract-rspack-plugin
export default {"container":"_5b296525","clear":"_35959f7b"};